import { apiClient } from '../../lib/api-client';
import type { AuthSession, AuthUser } from '../../lib/auth';

interface ApiResponse<T> { success: true; data: T }

export interface PatientPortalProfile {
  id: string;
  uhid: string;
  name: string;
  guardianName: string | null;
  guardianPhone: string | null;
  guardianRelationship: string | null;
  maritalStatus: string | null;
  bloodGroup: string | null;
  gender: string | null;
  dateOfBirth: string | null;
  phone: string | null;
  alternativePhone: string | null;
  email: string | null;
  address: string | null;
  district: string | null;
  state: string | null;
  country: string | null;
  postalCode: string | null;
}

export const authenticate = async (payload: { identifier: string; password: string; remember: boolean }) => {
  const response = await apiClient.post<ApiResponse<AuthSession>>('/auth/login', payload);
  return response.data.data;
};

export const fetchMe = async () => {
  const response = await apiClient.get<ApiResponse<AuthUser>>('/auth/me');
  return response.data.data;
};

export const endSession = async (): Promise<void> => {
  await apiClient.post('/auth/logout');
};

export const fetchPatientProfile = async () => {
  const response = await apiClient.get<ApiResponse<PatientPortalProfile>>('/auth/patient-profile');
  return response.data.data;
};

export const changeOwnPassword = async (payload: { currentPassword: string; newPassword: string; remember?: boolean }) => {
  const response = await apiClient.patch<ApiResponse<{ passwordChanged: true; token: string; user: AuthUser }>>('/auth/change-password', payload);
  return { token: response.data.data.token, user: response.data.data.user };
};
